import React, { useEffect, useRef, useState } from 'react';
import './Product.css';

const CoffretOreille = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  const galleryImages = [
    '/images/coffret_a_oreille/1.jpg',
    '/images/coffret_a_oreille/2.jpg',
    '/images/coffret_a_oreille/3.jpg',
    '/images/coffret_a_oreille/4.jpg',
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section className="product light-blue-bg" ref={sectionRef}>
      <div className="product-container">
        <div className="product-layout">
          {/* Product Description */}
          <div className={`product-text ${isVisible ? 'fade-in' : ''}`}>
            <h2 className="product-title">Coffret A Oreille Imprimé</h2>
            <p>
            Le coffret à oreilles FEFCO 0427 en cannelure est une solution d’emballage polyvalente et élégante, idéale pour protéger et expédier vos produits en toute sécurité. Grâce à son design robuste en carton cannelé, ses parois renforcées et sa fermeture extérieure à oreilles, il garantit une protection optimale. 
Sur-mesure et entièrement personnalisable, le coffret à oreilles s'adapte à des besoins variés de packaging et apporte une touche élégante à vos envois. 
            <br/><br/>
Le montage est rapide et les dimensions s'adaptent selon vos envies. Parfait pour l’e-commerce, les coffrets cadeaux, ou encore les boutiques, ce coffret d'emballage est à la fois pratique et esthétique. Offrez à vos produits une présentation soignée avec la fermeture à oreilles qui assure un maintien sécurisé. 
            </p>
          </div>

          {/* Image Gallery */}
          <div className={`product-gallery ${isVisible ? 'fade-in-delay' : ''}`}>
            <div className="gallery-grid">
              {galleryImages.map((image, index) => (
                <div key={index} className="gallery-item">
                  <img src={image} alt={`Coffret à oreilles ${index + 1}`} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CoffretOreille;